<script>
export default {
  name: 'MultiFormItems',
  props: {
    repeat: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    deepClone(vnodes, createElement) {
      return vnodes.map(vnode => this.cloneVNode(vnode, createElement))
    },
    cloneVNode(vnode, createElement) {
      const clonedChildren =
        vnode.children &&
        vnode.children.map(vnode => this.cloneVNode(vnode, createElement))
      const cloned = createElement(vnode.tag, vnode.data, clonedChildren)
      cloned.text = vnode.text
      cloned.isComment = vnode.isComment
      cloned.componentOptions = vnode.componentOptions
      cloned.elm = vnode.elm
      cloned.context = vnode.context
      cloned.ns = vnode.ns
      cloned.isStatic = vnode.isStatic
      cloned.key = vnode.key
      return cloned
    },
  },
  render(createElement) {
    const result = [createElement('div', {}, this.$slots.default)]
    for (let i = 1; i < this.repeat; i++) {
      result.push(
        createElement('div', {}, [
          ...this.deepClone(this.$slots.default, createElement),
        ]),
      )
    }
    return createElement('div', {}, result)
  },
}
</script>

<style scoped></style>
